var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:_vm.reference,staticClass:"qs_editor mb-1",attrs:{"options":_vm.editorOption},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }